import { findOccurrencesInDoc } from "./entityOccurrences";
import { entityEffectiveColor } from "./entityColors";
import { displayFileName } from "./fileNames";
import { isJust, type Maybe } from "./maybe";
import type { DatabaseEntrySummary } from "./outlineEntityTypes";
import { stripSceneFrontmatterLayers } from "./platform/sceneFrontmatter";
import { scanTextOf } from "./zwdoc/scanText";

export type TimelineCharacterChip = {
  id: string;
  kind: "character";
  label: string;
  entryFile: string;
  color: Maybe<string>;
};

export function timelineCharacterChips(
  raw: string,
  entries: DatabaseEntrySummary[],
  scene: string = "",
): TimelineCharacterChip[] {
  const scan = scanTextOf(raw);
  const text =
    scan.kind === "zwdoc"
      ? scan.projection.text
      : stripSceneFrontmatterLayers(scan.text).body;
  return entries.flatMap((entry) => {
    if (
      entry.isMap ||
      isJust(entry.fields.type) === false ||
      entry.fields.type.value !== "character"
    )
      return [];
    if (entry.fields.excludeFromScene.includes(scene)) return [];
    const label = displayFileName(entry.name);
    const matches = findOccurrencesInDoc(
      text,
      {
        name: label,
        aka: entry.fields.aka,
        plural: entry.fields.plural,
        adjective: entry.fields.adjective,
      },
      scan.kind === "markdown",
    );
    if (
      matches.length === 0 &&
      entry.fields.sceneLinks.some((link) => link.file === scene) === false
    )
      return [];
    return [
      {
        id: `character:${entry.name}`,
        kind: "character" as const,
        label,
        entryFile: entry.name,
        color: entityEffectiveColor(entry.fields.color, entry.fields.type),
      },
    ];
  });
}
